import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import {
  SetupProjectManagerCondition,
  SetupProjectManager,
} from 'models/setup/SetupProjectManager';
import { callApi } from 'utils/ApiUtil';

export const findSetupProjectManager = async (condition: SetupProjectManagerCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-manager`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupProjectManager[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectManager[];
};
